const SelectableGrid = ({
  items = [],
  getId    = (item) => item.ID ?? item.id,
  getLabel = (item) => item.Activity ?? item.label ?? String(item),
  selectedId = null,
  onClick = () => {},
}) => {
  const handleSelect = (item, e) => {
    const id = getId(item);
    onClick(id); // <-- send just the id so parent setState works
  };

  const handleKeyDown = (item, e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSelect(item, e);
    }
  };

  return (
    <div className="select-activity-container select-activity-container-wizard">
      <div
        className="select-activity-inner-container"
        role="listbox"
        aria-activedescendant={selectedId ? `sel-${selectedId}` : undefined}
      >
        {items && items.map((item) => {
          const id = getId(item);
          const label = getLabel(item);
          const isSelected = String(id) === String(selectedId); // tolerant to number/string

          return (
            <div
              key={id}
              id={`sel-${id}`}
              className={`activity-select-item-container selectable-grid-item ${isSelected ? "secondary-tab-active" : "secondary-tab-inactive"}`}
              onClick={(e) => handleSelect(item, e)}
              onKeyDown={(e) => handleKeyDown(item, e)}
              tabIndex={0}
              role="option"
              aria-selected={isSelected}
              data-id={id}
              data-title={label}
            >
              <div className="activity-select-item-content">
                 <p
                onClick={(e) => handleSelect(item, e)}
                data-id={id}
                data-title={label}
                >
                  {label}
                </p>
                <p id="item-count-p">{item.count}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectableGrid;
